import React, { useEffect, useState, useRef } from 'react'
import {useNavigate, Link} from 'react-router-dom'
import axios from 'axios';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { Modal } from 'antd';
import Inputmask from 'inputmask';
import ValidationMessage from './common/ValidationMessage';

const DashboardInfoCard = (props) => {
    const { items, onDelete } = props;
    const navigate = useNavigate();
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const protocol = window.location.protocol;
    const host = window.location.host;

    var active_status = '';
    if(items.is_active == null || items.is_active == 'Y'){
        active_status = 'Deactivate';
    } else {
        active_status = 'Activate';
    }

    const [addCreditModalIsOpen, setAddCreditModalIsOpen] = useState(false);
    const yearsArray  = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i);
    const monthsArray = Array.from({ length: 12 }, (_, i) => i + 1);
    const years = yearsArray.map(y => ({ label: y, value: y }));
    const months = monthsArray.map(m => ({ label: m, value: m }));

    const [isPayNow, setIsPayNow] = useState(false);
    const [paymentMethodForm, setPaymentMethodForm] = useState({
        credit_amount: "",
        name_on_card: "",
        card_number: "",
        validity: "",
        cvv: "",
        available_amount: items.available_amount,
        sass_id: items.sass_id,
        user_name : localStorage.getItem('system_username')
    });
    const [paymentMethodFormError, setPaymentMethodFormError] = useState({});
    const [businessInfo, setBusinessInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getBusinessDetails = async() => {
        try {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('systemAdminToken')
                }
            };
            const api_params = {
                sub_domain: items.biz_app_url,
                user_name: localStorage.getItem("system_username")
            }
            await axios.post(`${process.env.REACT_APP_API_URL}admin/valid-subdomains-permission`, api_params, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    if(res.data.data.businessData.length > 0){
                        localStorage.setItem('sass_id', res.data.data.businessData[0].sass_id);
                        localStorage.setItem('subdomain', res.data.data.businessData[0].biz_app_url);
                        localStorage.setItem('business_name', res.data.data.businessData[0].business_name);
                        localStorage.setItem('business_email', res.data.data.businessData[0].biz_email);
                        navigate(`/system-admin/${items.biz_app_url}/agents`);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } catch (error2) {
            console.error(error2)
        }  
    }
    
    const deleteConfirmation = async() => {
        await Swal.fire({
            text: 'Are you sure to delete this record ?',
            icon: 'error',
            showCancelButton: true,
            showConfirmButton : true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK, Delete',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const apiHeaders = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "x-access-token": localStorage.getItem('systemAdminToken'),
                    },
                };
                let reqObj = {
                    biz_id: items.sass_id,
                    user_name : localStorage.getItem('system_username')
                }
                try {
                    await axios.post(`${api_base_url}admin/delete-business`, reqObj, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            toast.success(res.data.message);
                            onDelete();
                        }
                        else if(res.data.status === 'error'){
                            toast.error(res.data.message);
                        }
                        else{
                            toast.error("There is an error");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
        })
    }
    const activeStatusChange = async() => {
        await Swal.fire({
            text: 'Are you sure to '+active_status+' this Business ?',
            icon: 'error',
            showCancelButton: true,
            showConfirmButton : true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK, Change',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const apiHeaders = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "x-access-token": localStorage.getItem('systemAdminToken'),
                    },
                };
                let reqObj = {
                    biz_id: items.sass_id,
                    user_name : localStorage.getItem('system_username'),
                    status: active_status == 'Deactivate' ? 'N' : 'Y'
                }
                try {
                    await axios.post(`${api_base_url}admin/change-business-status`, reqObj, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            toast.success(res.data.message);
                            onDelete();
                        }
                        else if(res.data.status === 'error'){
                            toast.error(res.data.message);
                        }
                        else{
                            toast.error("There is an error");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
        })
    }
    // this is for add credit ammount function 
    const validateField = (name, value) => {
        let error = "";
        if (name === "credit_amount") {
            if (!value || value.trim() === "") {
                error = "Credit amount is required";
            }
            else if((Number(value) < 250)){
                error = "Minimum credit amount is 250";
            }
        }
        if (name === "name_on_card") {
            if (!value || value.trim() === "") {
                error = "Name on card is required";
            } 
        }
        if (name === "card_number") {
            if (!value || value.trim() === "") {
                error = "Card number is required";
            } 
        }
        if (name === "validity") {
            if (!value || value.trim() === "") {
                error = "Validity is required";
            }
            else if(!/^\d{2}\/\d{4}$/.test(value)){
                error = "Enter validity in MM/YYYY format";
            }
            else{
                const [month, year] = value.split('/').map(Number);
                if (month < 1 || month > 12) {
                    error = "Month must be between 01 and 12";
                } else if (year < 2025 ) {
                    error = "Enter a valid year";
                }
            }
        }
        if (name === "cvv") {
            if (!value || value.trim() === "") {
                error = "CVV is required";
            } 
        }
        return error; 
    }
    const inputOnChangeHandler = (selectedOption, actionMeta) => {
        // ------ manage input ------ //
        if(selectedOption?.target){
            const { name, value, } = selectedOption.target;
            let fieldValue = value;
            if(name === 'credit_amount'){
                if(isPayNow){
                    return
                }
                fieldValue = value.replace(/[^0-9.]/g, '');
            }
            if(name === 'card_number'){
                fieldValue = value.replace(/[^0-9]/g, '');
            }
            if(name === 'cvv'){
                fieldValue = value.replace(/[^0-9]/g, '').slice(0, 4);
            }
            const fieldError = validateField(name, fieldValue);
            setPaymentMethodFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setPaymentMethodForm((prevData) => ({
                ...prevData,
                [name]: fieldValue,
            }));
        }
        // ------ manage select field ------ //
        if (actionMeta?.name) {
            const { name } = actionMeta;
            const fieldError = validateField(name, selectedOption);
            setPaymentMethodFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setPaymentMethodForm((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
        }
    }
    const payNowOnClickHandler = () => {
        let hasError = false;
        const newErrors = {};
        if (!paymentMethodForm.credit_amount) {
            newErrors.credit_amount = 'Credit amount is required';
            hasError = true;
        }
        else if (Number(paymentMethodForm.credit_amount) < 250) {
            newErrors.credit_amount = 'Minimum credit amount is 250';
            hasError = true;
        }
        if (hasError) {
            setPaymentMethodFormError((prevErrors) => ({
                ...prevErrors,
                ...newErrors
            }));
            return;
        }
        setPaymentMethodFormError({});
        setIsPayNow(true);
    }
    const onCloseHandler = () => {
        setPaymentMethodForm({
            credit_amount: "",
            name_on_card: "",
            card_number: "",
            validity: "",
            cvv: ""
        })
        setPaymentMethodFormError({})
    }
    const paymentMethodSaveHandler = async () => {
        const newErrors = { ...paymentMethodFormError };
        for (const key in paymentMethodForm) {
            const fieldError = validateField(key, paymentMethodForm[key]);
            if (!newErrors[key]) {
                newErrors[key] = fieldError;
            }
        }
        setPaymentMethodFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            let apiToken = '';
            if(loginUserType === 'A'){
                apiToken = localStorage.getItem('token')
            }
            else if(loginUserType === 'D'){
                apiToken = localStorage.getItem('developertoken')
            }
            else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }
            var api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            await axios.post(`${api_base_url}admin/add-credit`, paymentMethodForm, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    toast.success(res.data.message)
                    onCloseHandler()
                    setAddCreditModalIsOpen(false)
                    setIsPayNow(false)
                    onDelete()
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
            })
            .catch((error) => {
                console.error(error);
            })
        }
    }
    const inputRef = useRef(null);
    useEffect(() => {
        if(inputRef.current){
            Inputmask({ mask: '99/9999'}).mask(inputRef.current);
        }
    },[isPayNow]);

    let lastPaymentHistory = '';
    if(items.amount){
        lastPaymentHistory = (items?.currency ? items.currency + ' ' : '') + items.amount + (items.payment_date ? ' on ' + moment(items.payment_date).format("DD MMMM YYYY") : '');
    }

    return (
        <>
            <div className="col-md-12 mb-6">
                <div className="card">
                    <div className="card-body pb-0 ribbon ribbon-end ribbon-clip">
                        <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                            <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                    <div className="d-flex flex-column">
                                        <div className="d-flex align-items-center mb-2">
                                            <div className="text-gray-900 fs-2 fw-bold me-1">
                                                {items.business_name}
                                                <span className={`badge badge-${active_status === 'Activate' ? 'danger' : 'success'} ms-2`}>
                                                    {
                                                        active_status === 'Activate' ? 
                                                        'Inactive'
                                                        :
                                                        'Active'
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-wrap fw-semibold fs-6 pe-2 mb-2">
                                            <span className="badge badge-light-dark pe-3 me-2">
                                                <span className="badge badge-dark me-3">
                                                    Business id
                                                </span>
                                                {items.business_id}
                                            </span>
                                            <span className="badge badge-light-dark pe-3 me-2">
                                                <span className="badge badge-dark me-3">
                                                    Business url
                                                </span>
                                                <Link 
                                                    to={protocol+'//'+items.biz_app_url+'.'+ host}
                                                    target='_blank'
                                                    className='text-hover-primary'
                                                >
                                                    {protocol+'//'+items.biz_app_url+'.'+ host}
                                                </Link>
                                            </span>
                                            <span className="badge me-auto badge-light-dark pe-3">
                                                <span className="badge badge-dark me-3">
                                                    Active Agents
                                                </span>
                                                {items.bot_count}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex my-4">
                                        <button
                                            className={`btn btn-sm btn-dark me-2`}
                                            onClick={getBusinessDetails}
                                        >
                                            Manage Business
                                        </button>
                                        <div>
                                            <div 
                                                className="btn btn-sm btn-primary btn-icon"
                                                data-sai-menu-trigger="{default: 'click'}"
                                                data-sai-menu-attach='parent'
                                                data-sai-menu-placement='bottom-end'
                                            >
                                                <FontAwesomeIcon 
                                                    icon={faEllipsisVertical} 
                                                    className='fs-3'
                                                />
                                            </div>
                                            <div
                                                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
                                                data-sai-menu='true'
                                            >
                                                <div className='menu-item px-5'>
                                                    <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={()=>setAddCreditModalIsOpen(true)}>Add Credit</a>
                                                </div>
                                                <div className='menu-item px-5'>
                                                    <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={activeStatusChange}>{active_status}</a>
                                                </div>
                                                <div className='menu-item px-5'>
                                                    <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={deleteConfirmation}>Delete Business</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap flex-stack">
                                    <div className="d-flex flex-column flex-grow-1 pe-8">
                                        <div className="d-flex flex-wrap">
                                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fs-4 fw-bold text-gray-700">
                                                        { items?.currency || ''}
                                                    </div>
                                                </div>
                                                <div className="fw-semibold fs-6 text-gray-600">Currency</div>
                                            </div>
                                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fs-4 fw-bold text-gray-700">
                                                        { items?.billing_country || '' }
                                                    </div>
                                                </div>
                                                <div className="fw-semibold fs-6 text-gray-600">Billing country</div>
                                            </div>
                                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fs-4 fw-bold text-gray-700">
                                                        {
                                                            items?.biz_email || 'N/A'
                                                        }
                                                    </div>
                                                </div>
                                                <div className="fw-semibold fs-6 text-gray-600">
                                                    Email
                                                </div>
                                            </div>
                                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fs-4 fw-bold text-gray-700">
                                                        {
                                                            items?.biz_phone !=0 ? items?.biz_phone : 'N/A'
                                                        }
                                                    </div>
                                                </div>
                                                <div className="fw-semibold fs-6 text-gray-600">
                                                    Phone no
                                                </div>
                                            </div>
                                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fs-4 fw-bold text-gray-700">
                                                        <>
                                                            <span>
                                                                {items?.currency || ''}
                                                            </span>
                                                            <span className='ms-2'>
                                                                {items?.available_amount || '0.00'}
                                                            </span>
                                                        </>
                                                    </div>
                                                </div>
                                                <div className="fw-semibold fs-6 text-gray-600">
                                                    Credit remaining
                                                </div>
                                            </div>
                                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fs-4 fw-bold text-gray-700">
                                                        {lastPaymentHistory}
                                                       {/* INR 20.00 on 25 june 2025 */}
                                                       {/* Payment history not yet */}
                                                    </div>
                                                </div>
                                                <div className="fw-semibold fs-6 text-gray-600">
                                                    Last payment
                                                </div>
                                            </div>
                                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="fs-4 fw-bold text-gray-700">
                                                        {
                                                            items.license_validity_end_date ? 
                                                            moment(items.license_validity_end_date).format("DD MMMM YYYY")
                                                            :
                                                            ''
                                                        }
                                                    </div>
                                                </div>
                                                <div className="fw-semibold fs-6 text-gray-600">
                                                    Valid till
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={addCreditModalIsOpen}
                title={null}
                footer={null}
            >
                <div className='row overflow-y-auto'>
                    <div className='col-md-12'>
                        <div className="text-center mb-5">
                            <h1 className="text-gray-800 mb-2 fs-2x">
                                Add credit
                            </h1>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                <span className="required">Add Credit</span>
                            </label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    INR
                                </span>
                                <input 
                                    type="text" 
                                    className="form-control form-control-solid" 
                                    placeholder="Add credit amount" 
                                    name="credit_amount"
                                    onChange={inputOnChangeHandler}
                                    disabled={isPayNow}
                                    value={paymentMethodForm.credit_amount}
                                    min="250"
                                />
                            </div>
                            {
                                paymentMethodFormError.credit_amount && 
                                <ValidationMessage 
                                    className='text-danger mt-2 lh-sm' 
                                    message ={paymentMethodFormError.credit_amount}
                                />
                            }
                        </div>
                        <div className='text-end'>
                            {
                                !isPayNow && (
                                    <>
                                        <button 
                                            className="btn btn-dark me-2"
                                            onClick={() => {
                                                setAddCreditModalIsOpen(false);
                                                onCloseHandler()
                                            }}
                                        >
                                            Close
                                        </button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={payNowOnClickHandler}
                                            disabled={isPayNow}
                                        >
                                            Pay now
                                        </button>
                                    </>
                                )
                            }
                        </div>
                    </div>
                    {
                        isPayNow &&
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">Name On Card</span>
                                        </label>
                                        <input
                                            type="text" 
                                            className="form-control form-control-solid" 
                                            placeholder="Name on card"
                                            name="name_on_card"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.name_on_card}
                                        />
                                        {
                                            paymentMethodFormError.name_on_card && 
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.name_on_card}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">
                                                Card number
                                            </span>
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-solid"
                                            placeholder="Card number"
                                            name="card_number"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.card_number}
                                        />
                                        {
                                            paymentMethodFormError.card_number &&
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.card_number}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-8'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">
                                                Validity
                                            </span>
                                        </label>
                                        <input 
                                            type="text" 
                                            ref={inputRef} 
                                            className="form-control form-control-solid" 
                                            placeholder="MM/YYYY"
                                            name="validity"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.validity}
                                        />
                                        {
                                            paymentMethodFormError.validity && 
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.validity}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className="d-flex flex-column mb-7 fv-row fv-plugins-icon-container">
                                        <label className="d-flex align-items-center fs-6 fw-semibold form-label mb-2">
                                            <span className="required">
                                                CVV
                                            </span>
                                        </label>
                                        <input
                                            type="text" 
                                            className="form-control form-control-solid" 
                                            placeholder="CVV"
                                            name="cvv"
                                            onChange={inputOnChangeHandler}
                                            value={paymentMethodForm.cvv}
                                        />
                                        {
                                            paymentMethodFormError.cvv && 
                                            <ValidationMessage 
                                                className='text-danger mt-2 lh-sm' 
                                                message ={paymentMethodFormError.cvv}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className='col-md-12 text-end'>
                                    <button 
                                        className="btn btn-dark me-3"
                                        onClick={() => {
                                            setAddCreditModalIsOpen(false);
                                            setIsPayNow(false);
                                            onCloseHandler()
                                        }}
                                    >
                                        Close
                                    </button>
                                    <button 
                                        className="btn btn-primary"
                                        onClick={paymentMethodSaveHandler}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Modal> 
        </>
    )
}
export default DashboardInfoCard